<script lang="ts" setup>
import { useOut } from "@/features/out/useOut";
import { useSavePool } from "@/features/pool/usePool";
import { useShouldHideControlButtons } from "@/features/out/controls/useShouldHideControlButtons";

defineProps({
  showTrigger: Boolean,
  showStop: Boolean,
});

const out = useOut();
const savePool = useSavePool();

const setStatusAndSave = (status: number) => {
  out.value.status = status;
  savePool(true);
};

const shouldHide = useShouldHideControlButtons();
</script>

<template>
  <button
    class="btn--primary"
    v-if="!shouldHide && (out.status === 0 || out.status === 2) && showTrigger"
    @click="setStatusAndSave(1)"
  >
    {{ $t("TriggNow") }}
  </button>
  <button
    class="btn--primary"
    v-if="!shouldHide && (out.status === 1 || out.status === 3) && showStop"
    @click="setStatusAndSave(0)"
  >
    {{ $t("StopNow") }}
  </button>
</template>
